import { Card, CardBody, Skeleton, TableControl, TableSkeleton } from '@/_components';
import { ContainerLayout, StickyPageHeaderSkeletonWithButtons } from '@/_containers';

import { InvoicesBottomSplitView } from './invoices-bottom-split-view';
import { InvoicesSplitView } from './invoices-split-view';

export function InvoicesMainLoading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} />

      <div className="mt-2 px-6">
        <Card>
          <CardBody className="space-y-4">
            <TableControl />

            <InvoicesSplitView
              topContent={<TableSkeleton numberOfColumns={8} containerClassName="h-full rounded-b-none" />}
              bottomContent={
                <InvoicesBottomSplitView
                  leftContent={
                    <div className="border-c-border h-full rounded-t-none rounded-b-xl border">
                      <TableSkeleton
                        numberOfColumns={7}
                        maxRows={6}
                        equalWidthCols
                        containerClassName="h-full rounded-none border-0"
                      />
                    </div>
                  }
                  rightContent={
                    <div className="border-c-border flex h-full flex-col rounded-t-none rounded-b-xl border">
                      <div className="space-y-2 px-2 py-2">
                        <Skeleton className="h-5 w-1/2" />
                        <Skeleton className="h-8 w-full" />
                        <Skeleton className="h-8 w-full" />
                        <Skeleton className="h-24 w-full" />
                      </div>
                      <div className="border-c-border-muted bg-c-background-muted mt-auto flex gap-1 border-t px-2 py-1">
                        <Skeleton className="h-7 w-14 rounded-lg" />
                        <Skeleton className="h-7 w-14 rounded-lg" />
                        <Skeleton className="h-7 w-14 rounded-lg" />
                      </div>
                    </div>
                  }
                />
              }
            />

            <div className="border-c-border flex items-center justify-between rounded-xl border px-4 py-3">
              <Skeleton className="h-5 w-24" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-8 w-8 rounded-lg" />
                <Skeleton className="h-8 w-20 rounded-lg" />
                <Skeleton className="h-8 w-8 rounded-lg" />
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </ContainerLayout>
  );
}
